export const diGroups = {
  paging: { total: 2, count: 1000, totalPages: 1, currentPage: 0 },
  groups: [
    {
      id: 'group1.1',
      idType: 'EXTERNAL_ID',
      displayInfoTitles: ['DI Group Title 1.1', 'DI Group Title 1.2'],
      groupType: 'MAIN',
      groupsByDisplayInfoTitle: [
        {
          groupId: 'group1.1',
          title: 'DI1.1 Group Title',
          externalId: 'group1ext',
          clientId: 'string',
          merchantId: 'string',
          groupType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
        {
          groupId: 'group1.2',
          title: 'DI1.2 Group Title',
          externalId: 'group1ext',
          clientId: 'string',
          merchantId: 'string',
          groupType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
      ],
    },
    {
      id: 'group2.1',
      idType: 'EXTERNAL_ID',
      displayInfoTitles: ['DI Group Title 2.1', 'DI Group Title 2.2'],
      groupType: 'MAIN',
      groupsByDisplayInfoTitle: [
        {
          groupId: 'group2.1',
          title: 'DI Group Title 2.1',
          externalId: 'group1ext',
          clientId: 'string',
          merchantId: 'string',
          groupType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
        {
          groupId: 'group2.2',
          title: 'DI Group Title 2.2',
          externalId: 'group1ext',
          clientId: 'string',
          merchantId: 'string',
          groupType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
      ],
    },
    {
      id: 'group3.1',
      idType: 'EXTERNAL_ID',
      displayInfoTitles: ['DI Group Title 3.1', 'DI Group Title 3.2'],
      groupType: 'OPTION_GROUP',
      groupsByDisplayInfoTitle: [
        {
          groupId: 'group3.1',
          title: 'DI Group Title 3.1',
          externalId: 'group1ext',
          clientId: 'string',
          merchantId: 'string',
          groupType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
        {
          groupId: 'group3.2',
          title: 'DI Group Title 3.2',
          externalId: 'group1ext',
          clientId: 'string',
          merchantId: 'string',
          groupType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
      ],
    },
    {
      id: 'group.id',
      idType: 'ID',
      displayInfoTitles: ['DI Group Title ID.1', 'DI Group Title ID.2'],
      groupType: 'MAIN',
      groupsByDisplayInfoTitle: [
        {
          groupId: 'group3.1',
          title: 'DI Group Title ID.1',
          externalId: 'group1ext',
          clientId: 'string',
          merchantId: 'string',
          groupType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
        {
          groupId: 'group3.2',
          title: 'DI Group Title ID.2',
          externalId: 'group1ext',
          clientId: 'string',
          merchantId: 'string',
          groupType: 'MAIN',
          price: 10000,
          startDate: 'string',
          endDate: 'string',
          outOfStock: false,
          outOfStockToday: false,
          createdDate: 'string',
          updatedDate: 'string',
        },
      ],
    },
  ],
};
